import { z } from "zod";

const toText = (value) => {
  if (value == null) return "";
  if (typeof value === "number") return String(value);
  return value;
};

const requiredText = (label) =>
  z.preprocess(
    toText,
    z
      .string({ required_error: `${label} is required` })
      .trim()
      .min(1, `${label} is required`)
  );

const optionalText = z.preprocess(toText, z.string().trim().optional());

export const Step5Schema = z
  .object({
    priorInsuranceStatus: requiredText("Prior insurance status"),
    priorInsuranceCarrier: optionalText,
    bodilyInjuryLimits: optionalText,
    yearsWithCarrier: optionalText,
    driversListed: z.boolean().default(true),
    pipClaims: requiredText("PIP claims"),
    totalResidents: requiredText("Total residents"),
    primaryResidence: requiredText("Primary residence"),
    rentersDiscount: z.boolean().default(false),
  })
  .superRefine((data, ctx) => {
    if (data.priorInsuranceStatus === "No") return;

    const missing = (value) => !String(value || "").trim();

    if (missing(data.priorInsuranceCarrier)) {
      ctx.addIssue({
        code: "custom",
        path: ["priorInsuranceCarrier"],
        message: "Prior insurance carrier is required",
      });
    }

    if (missing(data.bodilyInjuryLimits)) {
      ctx.addIssue({
        code: "custom",
        path: ["bodilyInjuryLimits"],
        message: "Bodily injury limits is required",
      });
    }

    if (missing(data.yearsWithCarrier)) {
      ctx.addIssue({
        code: "custom",
        path: ["yearsWithCarrier"],
        message: "Years with carrier is required",
      });
    }
  });
